import React from 'react';
import { View } from 'react-native';

interface FixedView$Props {
  className?: string;
  style: React.CSSProperties;
  children: JSX.Element;
}

export const FixedView = ({ className, style, children }: FixedView$Props) => (
  <span
    className={className}
    style={{
      position: 'fixed',
      display: 'flex',
      ...style,
    }}
  >
    <View
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
      }}
    >
      {children}
    </View>
  </span>
);

export default FixedView;
